import ServerConnection from "../ServerConnection/ServerConnection";

export function loadContactPersonDuplicates(details) {
  return ServerConnection.get("contactperson/duplicates", {
    params: {
      name: details.name || "",
      email: details.email || "",
      phoneNumber: details.phoneNumber || "",
      ignoreId: details.ignoreId,
    },
  }).then((response) => (Array.isArray(response.data) ? response.data : []));
}

export function contactPersonDuplicateDetails(duplicate) {
  var details = [];
  if (duplicate.email) {
    details.push(duplicate.email);
  }
  if (duplicate.phoneNumber) {
    details.push(duplicate.phoneNumber);
  }
  if (duplicate.teamNames) {
    details.push(duplicate.teamNames);
  }
  return details.join(" · ");
}
